// extracted by mini-css-extract-plugin
export var blockedMessage = "_76-3";
export var blockedOverlay = "_76-1";
export var fadeIn = "_76-2";
export var hereLink = "_76-0";
export var slideUp = "_76-4";